import React, { useState } from 'react';

const ActionMenu = ({ group, setGroupToDelete, setShowModal, openConfirmModal }) => {
    const [open, setOpen] = useState(false);
    const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
    const ref = React.useRef(null);

    React.useEffect(() => {
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const handleToggle = () => {
        if (!open && ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const menuHeight = 110;
            const spaceBelow = window.innerHeight - rect.bottom;
            const top = spaceBelow < menuHeight
                ? rect.top - menuHeight + window.scrollY
                : rect.bottom + window.scrollY;
            setMenuPos({ top, left: rect.right - 180 });
        }
        setOpen(!open);
    };

    const menuItems = [
        {
            icon: 'bi-phone-minus',
            label: 'Delete Number',
            color: '#f59e0b',
            onClick: () => {
                setGroupToDelete(group._id);
                setShowModal(true);
                setOpen(false);
            },
        },
        {
            icon: 'bi-trash',
            label: 'Delete Group',
            color: '#dc2626',
            onClick: () => { openConfirmModal(group._id); setOpen(false); },
        },
    ];

    return (
        <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
            <button style={menuStyles.trigger} onClick={handleToggle}>
                <i className="bi bi-three-dots-vertical"></i>
            </button>
            {open && (
                <div style={{ ...menuStyles.menu, position: 'fixed', top: menuPos.top, left: menuPos.left }}>
                    {menuItems.map((item, i) => (
                        <button key={i} style={menuStyles.item} onClick={item.onClick}
                            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                            onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                            <span style={{ ...menuStyles.itemIcon, background: item.color + '15', color: item.color }}>
                                <i className={`bi ${item.icon}`}></i>
                            </span>
                            <span style={{ ...menuStyles.itemLabel, color: item.color }}>{item.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

const menuStyles = {
    trigger: { background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '6px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#6b7280', fontSize: '15px' },
    menu: { position: 'absolute', right: 0, top: '36px', background: 'white', borderRadius: '10px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', border: '1px solid #f3f4f6', minWidth: '170px', zIndex: 1000, padding: '6px' },
    item: { display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '8px 10px', border: 'none', background: 'white', borderRadius: '6px', cursor: 'pointer', textAlign: 'left' },
    itemIcon: { width: '28px', height: '28px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', flexShrink: 0 },
    itemLabel: { fontSize: '13px', fontWeight: '500' },
};

const GroupTable = ({ currentGroups, navigate, setShowModal, setGroupToDelete, openConfirmModal, handleDownload }) => (
    <div className="table-responsive">
        <table style={styles.table}>
            <thead>
                <tr style={styles.tableHead}>
                    <th style={styles.th}>Group Name</th>
                    <th style={styles.th}>Type</th>
                    <th style={styles.th}>Country Code</th>
                    <th style={styles.th}>Count</th>
                    <th style={styles.th}>Action</th>
                </tr>
            </thead>
            <tbody>
                {currentGroups.map((group) => (
                    <tr key={group._id} style={styles.tr}>
                        <td style={styles.td}>{group.group_name}</td>
                        <td style={styles.td}>
                            <span style={styles.typeBadge}>{group.contact_type}</span>
                        </td>
                        <td style={styles.td}>+91</td>
                        <td style={styles.td}>
                            <div style={styles.countCell}>
                                <span>{group.total_count}</span>
                                <button style={styles.downloadBtn} onClick={() => handleDownload(group._id)} title="Download File">
                                    <i className="bi bi-download"></i>
                                </button>
                            </div>
                        </td>
                        <td style={styles.td}>
                            {!group.file_def && (
                                <ActionMenu
                                    group={group}
                                    setGroupToDelete={setGroupToDelete}
                                    setShowModal={setShowModal}
                                    openConfirmModal={openConfirmModal}
                                />
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

const styles = {
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '14px' },
    tableHead: { background: '#eff6ff' },
    th: { padding: '12px 14px', textAlign: 'left', fontSize: '12px', fontWeight: '700', color: '#1565c0', textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap', borderBottom: '2px solid #bfdbfe' },
    tr: { borderBottom: '1px solid #f3f4f6' },
    td: { padding: '12px 14px', color: '#374151', verticalAlign: 'middle' },
    typeBadge: { background: '#eff6ff', color: '#1565c0', padding: '3px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
    countCell: { display: 'flex', alignItems: 'center', gap: '8px' },
    downloadBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#1565c0', fontSize: '14px', padding: 0, display: 'flex', alignItems: 'center' },
};

export default GroupTable;
